import Vue from 'vue'
import VueRouter from 'vue-router'
import Dash from '../views/Dash.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/user_signup/:token',
    name: 'UserSignup',
    component: () => import(/* webpackChunkName: "home" */ '../views/UserSignup.vue')
  },
  {
    path: '/',
    name: 'Dash',
    component: Dash,
    children: [
      {
        path: '/admin',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
      },
      {
        path: '/menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "home" */ '../views/Menu.vue')
      },
      {
        path: '/menu/choices/:id',
        name: 'MenuChoice',
        component: () => import(/* webpackChunkName: "home" */ '../views/MenuChoices.vue')
      },
      {
        path: '/message',
        name: 'Message',
        component: () => import(/* webpackChunkName: "home" */ '../views/Messages.vue')
      },
      {
        path: '/session',
        name: 'Sessions',
        component: () => import(/* webpackChunkName: "home" */ '../views/Session.vue')
      },
      {
        path: '/session/:id/messages',
        name: 'SessionMessages',
        component: () => import(/* webpackChunkName: "home" */ '../views/Messages.vue')
      },
      {
        path: '/contactcenter',
        name: 'ContactCenterRecords',
        component: () => import(/* webpackChunkName: "home" */ '../views/ContactCenterRecords.vue')
      },
      {
        path: '/payforinsurance',
        name: 'PayforInsuranceRecords',
        component: () => import(/* webpackChunkName: "home" */ '../views/PayforInsuranceRecords.vue')
      },
      {
        path: '/permission',
        name: 'Permission',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Permission.vue')
      },
      {
        path: '/role',
        name: 'Role',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Role.vue')
      },
      {
        path: '/user',
        name: 'User',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/User.vue')
      },
      {
        path: '/chat/messages/:id/:sessionId',
        name: 'ChatMessage',
        component: () => import(/* webpackChunkName: "home" */ '../views/chat/ChatWindowComponent.vue')
      },
      {
        path: '/reference',
        name: 'ReferenceRecords',
        component: () => import(/* webpackChunkName: "home" */ '../views/ReferenceRecords.vue')
      },
      {
        path: '/sticker-details',
        name: 'StickerDetails',
        component: () => import(/* webpackChunkName: "home" */ '../views/StickerDetails.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
